import {Localized} from "@fluent/react";
import React, {useCallback, useState} from "react";

import NewUserDialog from "./NewUserDialog";
import type FetchStatus from "../../store/FetchStatus";
import {organisationService} from "../../store/services/organisationService";
import {userService} from "../../store/services/userService";
import PaginatedSingleSelectionAutocomplete from "../../utils/autocomplete/PaginatedSingleSelectionAutocomplete";

function NewGroupUserDialog(props: {
	titleElementId: string;
	groupName: string;
	onCancel: () => void;

	dialogRef?: React.Ref<{status: () => FetchStatus}>;
}) {
	const {groupName} = props;

	const [organisation, setOrganisation] = useState("");

	const [emptyOrg, setEmptyOrg] = useState(false);

	const fetchOrganisations = useCallback(
		(query: string, pageSize: number) => {
			return organisationService.searchGroupOrganisations(
				groupName,
				{query},
				{field: "displayName"},
				pageSize
			);
		},
		[groupName]
	);

	return (
		<NewUserDialog
			onCancel={props.onCancel}
			titleElementId={props.titleElementId}
			dialogRef={props.dialogRef}
			onCreate={(u) => userService.createUser(organisation, u)}
			topInput={{
				input: (
					<PaginatedSingleSelectionAutocomplete
						label={
							<Localized id="new-group-user-dialog-label-organisation">
								Organisation
							</Localized>
						}
						required
						error={emptyOrg}
						pageFetcher={fetchOrganisations}
						optionMapper={(v) => ({
							id: v.name,
							name: v.displayName,
							secondaryName: v.name,
						})}
						onChange={(name) => {
							setOrganisation(name ?? "");
							setEmptyOrg(false);
						}}
					/>
				),
				validate() {
					setEmptyOrg(organisation === "");
					return organisation !== "";
				},
			}}
			createLinks={(id) => ({
				profile: `/users/${id}`,
				roles: `/users/${id}/roles`,
			})}
		/>
	);
}

export default NewGroupUserDialog;
